import { createSlice } from "@reduxjs/toolkit";
//import settings from "settings.json";
//const { api } = settings[process.env.NODE_ENV] ? settings[process.env.NODE_ENV] : settings["production"];
import I18n from "./../../controllers/i18n";

const { localStorage } = window;
const langParams = new URLSearchParams(window.location.search);
const queryLng = langParams.get("lng");
const navigatorlng = window.navigator.language?.slice(0, 2);
const storedLanguage =
  queryLng || localStorage.getItem("i18nextLng") || navigatorlng || "nl";

let i18n = new I18n(storedLanguage);

const i18nSlice = createSlice({
  name: "collection",
  initialState: {
    language: i18n._language,
    translations: i18n._translations,
    availableLanguages: i18n._availableLanguages,
  },
  reducers: {
    setLanguage(state, action) {
      const language = action.payload;
      state.language = language;
      i18n.setLanguage(language);
      localStorage.setItem("i18nextLng", language);
    },
  },
});

const translate = (...args) => {
  return i18n.translate(...args);
};

const getLanguage = () => {
  return i18n.getLanguage();
};

export { translate };
export const { setLanguage } = i18nSlice.actions;
export { getLanguage };
export default i18nSlice;
